
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiExpand as ObiExpandElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-expand.js';
 
 
 

 
 export const ObiExpand = createComponent({
   react: React,
   tagName: 'obi-expand',
   elementClass: ObiExpandElement,
   events: {
     
   }
  });
 
 